// extracted by mini-css-extract-plugin
export var activeFilterButton = "_lf-c";
export var backButton = "_lf-4";
export var backIcon = "_lf-5";
export var chevronShortcut = "_lf-6";
export var container = "_lf-1";
export var editor = "_lf-8";
export var editorWrapper = "_lf-7";
export var prefix = "_lf-2";
export var searchIcon = "_lf-3";
export var suffix = "_lf-9";
export var suffixContent = "_lf-a";
export var suffixText = "_lf-b";
export var wrapper = "_lf-0";